import { Icon } from "@mdi/react";
import { ReactElement } from "react";

import { mdiDelete, mdiFormatListBulleted } from "@mdi/js";
import { MenuProps } from "antd";
import styled from "styled-components";

import { Tooltip } from "components/base";
import { IconButton } from "components/forecasting/Shared";

export type MoreOptionsPropsType = {
  product: string;
  isSync: boolean;
  switchToSegmentMode: (product: string) => void;
  setOnTime: (onTime: { open: boolean; product: string }) => void;
  deleteProduct: (product: string) => void;
  kind: string;
  projectPermissions: { canEditTypeWells: boolean };
};

export type OptionsType = {
  key: string;
  onClick: () => void;
  label: ReactElement | null;
  danger?: boolean;
  disabled?: boolean;
};

export const ProductMoreOptions = (props: MoreOptionsPropsType): MenuProps["items"] => {
  const options: OptionsType[] = [
    {
      key: "details",
      onClick: () => {
        props.switchToSegmentMode(props.product);
      },
      label: (
        <MoreMenuItem>
          <Tooltip title="View Segment Details">
            <IconButton
              size={"small"}
              icon={<Icon path={mdiFormatListBulleted} size={"16px"} />}
            />
          </Tooltip>
        </MoreMenuItem>
      )
    }
  ];

  if (!props.isSync) {
    options.push({
      disabled: !props.projectPermissions.canEditTypeWells,
      key: "delete",
      danger: true,
      onClick: () => props.deleteProduct(props.product),
      label: (
        <MoreMenuItem>
          <Tooltip title="Delete Product">
            <IconButton
              data-testid="forecaster-delete-product-button"
              size={"small"}
              danger
              icon={<Icon path={mdiDelete} size={"16px"} />}
            />
          </Tooltip>
        </MoreMenuItem>
      )
    });
  }
  return options;
};

const MoreMenuItem = styled.div`
  .ant-btn {
    border: none;
    box-shadow: none;
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }
`;
